<p-fieldset [legend]="topBarDocumentTitle" [toggleable]="true">
    <app-stat-card [cardList]="userHomeDocumentData.documentCards">
      <ng-template #statCard let-singleCard>
        <div class="col-12 md:col-6 lg:col-3 card-padding">
        <app-stat-card-data [singleCard]="singleCard"></app-stat-card-data>
        <span *ngIf="singleCard.name === myAssignedAdminCardLabel">{{myAssignedAdminNoteText}}</span>
        </div>
      </ng-template>
    </app-stat-card>  
</p-fieldset>

